<template>
<div class="model-16">
    <div class="blank" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color,height:editablePageConfig.editable_page_config_content.height+'px'}"></div>
</div>
</template>

<script>
export default {
  name: 'Model16',
  data () {
    return {
    }
  },
  props: ['editablePageConfig','editablePage'],

  methods: {
    productClick(goods_id) {
      this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: goods_id } })
    }
  }
}
</script>

<style lang="scss" scoped>
	.model-16 .blank{
		border-radius: 5px;
	}
</style>
